/**
 * @returns {Object}
 */
export function maxSmsValue() {
    
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ctrl) {

            const validate = (value) => {

                const comparisonModel = attr.maxSmsValue;

                if (!value || !comparisonModel) {

                    ctrl.$setValidity('maxSmsValue', true);

                } else {

                    ctrl.$setValidity('maxSmsValue', parseFloat(value * comparisonModel) <= 1000000);
                }

                return value;
            };

            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.push(validate);

            attr.$observe('maxSmsValue', (comparisonModel) => {

                return validate(ctrl.$viewValue);
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/max-sms-value.directive.js